import { useMemo } from 'react';

import { farmWorkOrdersService } from '../../../../services/farmWorkOrdersService';
import { createApiSlice } from '../../utils/createApiSlice';

const createFarmWorkOrderSlice = createApiSlice({
  reducerPath: ['newGrowths', 'farmWorkOrders', 'createFarmWorkOrder'],
  apiFunction: farmWorkOrdersService.createFarmWorkOrderV2,
  apiArgumentsFn: ({ growerId, seasonId, farmId, data }) => [
    growerId,
    seasonId,
    farmId,
    data
  ]
});

const { actions, useApiSelectors } = createFarmWorkOrderSlice;

export const createFarmWorkOrderActions = actions;

export const useCreateFarmWorkOrderSelectors = () => {
  const { inProgress, errorMessage, success, updatedAt } = useApiSelectors();

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      updatedAt
    }),
    [errorMessage, inProgress, success, updatedAt]
  );
};

export default createFarmWorkOrderSlice;
